import { createSelector } from '../reselect';
import { getNewStats, total, simpleChart, safeDivide, simpleChart2 } from '../generalUtils';

const providerId = 'mountain';

const mountainSpend = createSelector([getNewStats], (stats) => total(stats[providerId], 'spend'));
const mountainSpendChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'spend')
);

const mountainConversionValue = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'conversion_value')
);
const mountainConversionValueChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'conversion_value')
);

const mountainVisits = createSelector([getNewStats], (stats) => total(stats[providerId], 'visits'));
const mountainVisitsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'visits')
);

const mountainImpressions = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'impressions')
);
const mountainImpressionsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'impressions')
);

const mountainConversions = createSelector([getNewStats], (stats) =>
  total(stats[providerId], 'conversions')
);
const mountainConversionsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], 'conversions')
);

const mountainRoas = createSelector(
  [mountainConversionValue, mountainSpend],
  (mountainConversionValue, mountainSpend) => {
    return safeDivide(mountainConversionValue, mountainSpend);
  }
);
const mountainRoasChart = createSelector(
  [mountainConversionValueChart, mountainSpendChart],
  (mountainConversionValueChart, mountainSpendChart) =>
    simpleChart2(mountainConversionValueChart, mountainSpendChart)
);

const mountainConversionRate = createSelector(
  [mountainConversions, mountainVisits],
  (mountainConversions, mountainVisits) => {
    return safeDivide(100 * mountainConversions, mountainVisits);
  }
);
const mountainConversionRateChart = createSelector(
  [mountainConversionsChart, mountainVisitsChart],
  (mountainConversionsChart, mountainVisitsChart) =>
    simpleChart2(mountainConversionsChart, mountainVisitsChart, { chart1yMultiplier: 100 })
);

const mountainAverageOrderValue = createSelector(
  [mountainConversionValue, mountainConversions],
  (mountainConversionValue, mountainConversions) => {
    return safeDivide(mountainConversionValue, mountainConversions);
  }
);

const mountainAverageOrderValueChart = createSelector(
  [mountainConversionValueChart, mountainConversionsChart],
  (mountainConversionValueChart, mountainConversionsChart) =>
    simpleChart2(mountainConversionValueChart, mountainConversionsChart)
);

const mountainCostPerAcquisition = createSelector(
  [mountainSpend, mountainConversions],
  (mountainSpend, mountainConversions) => {
    return safeDivide(mountainSpend, mountainConversions);
  }
);

const mountainCostPerAcquisitionChart = createSelector(
  [mountainSpendChart, mountainConversionsChart],
  (mountainSpendChart, mountainConversionsChart) =>
    simpleChart2(mountainSpendChart, mountainConversionsChart)
);

const mountainCostPerVisit = createSelector(
  [mountainSpend, mountainVisits],
  (mountainSpend, mountainVisits) => {
    return safeDivide(mountainSpend, mountainVisits);
  }
);

const mountainCostPerVisitChart = createSelector(
  [mountainSpendChart, mountainVisitsChart],
  (mountainSpendChart, mountainVisitsChart) => simpleChart2(mountainSpendChart, mountainVisitsChart)
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    mountainSpend,
    mountainSpendChart,
    mountainRoas,
    mountainRoasChart,
    mountainImpressions,
    mountainImpressionsChart,
    mountainConversions,
    mountainConversionsChart,
    mountainConversionRate,
    mountainConversionRateChart,
    mountainAverageOrderValue,
    mountainAverageOrderValueChart,
    mountainCostPerAcquisition,
    mountainCostPerAcquisitionChart,
    mountainCostPerVisit,
    mountainCostPerVisitChart,
    mountainConversionValue,
    mountainConversionValueChart,
  },
};
